export default class CompileError {
    constructor(title, i18nKey, ...params) {
        /*        super(i18nKey);
                if(Error.captureStackTrace) {
                    Error.captureStackTrace(this, CompileError);
                }*/
        this.title = title;
        this.i18nKey = i18nKey;
        this.params = params;
    }
}

